import clsx from 'clsx';
import { ReactNode } from 'react';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import EditablePictureContainer from '~components/generic/editable-picture/EditablePictureContainer';
import { Link } from '~components/generic/elements/Link/Link';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import { imageProportions } from '~services/responsive-helpers';

export const ModuleImageLink = ({
  data,
  uploadFileAction,
  editing,
  className,
  onChange,
  isEditing,
  entityDef,
}: IEntityComponentProps) => {
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const imageId = getRelatedEntityIds(data, 'field_image')[0];
  const hasLink = Boolean(data.attributes.field_link_internal || data.attributes.field_link_external?.uri);
  const wrapperLink = (children: ReactNode) =>
    editing || !hasLink ? (
      <span>{children}</span>
    ) : (
      <Link id={data.attributes.field_link_internal} url={data.attributes.field_link_external?.uri}>
        {children}
      </Link>
    );
  const imgColClass = clsx({
    col: true,
    'col-12': true,
    'u-margin-top-md': true,
    'c-module--type--text-image': true,
  });
  const moduleClasses = clsx({
    ...className.module,
    /*'u-padding-vertical-xl': false*/
  });
  const containerClasses = clsx({
    ...className.container,
    'px-0': true,
    relative: true,
  });

  const showBorder = Boolean(data.attributes.field_show_border);
  const borderRadius = parseInt(data.attributes.field_border_radius || '0', 10);
  const imageProportionKey = data.attributes.field_image_proportions ?? 5;
  const showOriginal = data.attributes.field_image_proportions === 5;

  return (
    <div className={moduleClasses} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={containerClasses}>
        <div className="row c-module__header">
          <div className="col col-12">
            <EditableField
              hide={content.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={content.field_title.value}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className="row d-flex flex-wrap c-module__content">
          {!content.field_hide_text && (
            <div className="col col-12 u-margin-top-sm o-field-text">
              <EditableField
                entityType={data.type}
                fieldName="attributes.field_text.value"
                data={content.field_text && content.field_text.value}
                editing={editing}
                onChange={onChange}
              />
            </div>
          )}
          <div className={imgColClass}>
            {wrapperLink(
              <EditablePictureContainer
                showWhenEmpty={true}
                entityType={data.type}
                fieldName="relationships.field_image"
                entityId={imageId}
                editing={editing}
                proportions={imageProportions[imageProportionKey]}
                onChangeImage={onChange}
                onUpload={uploadFileAction}
                placeholder={isEditing && entityDef.fields['relationships.field_image'].options.placeholder}
                showOriginal={showOriginal}
                border={showBorder}
                borderRadius={borderRadius}
              />,
            )}
          </div>
          {!content.field_hide_caption && (
            <div className="col col-12 o-field-text field--name-field-caption">
              <EditableField
                entityType={data.type}
                fieldName="attributes.field_caption.value"
                data={content.field_caption && content.field_caption.value}
                editing={editing}
                onChange={onChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModuleImageLink;
